import { motion } from "framer-motion";

const About = () => {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-white text-gray-800 overflow-hidden">
      {/* Hero Section */}
      {/* Page Top */}
      <div className="page-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="page-title">About</h1>
              <h2 className="page-description">Gemstone Real Estate Ltd.</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Project Section 1 */}
      <div className="max-w-7xl mx-auto px-6 py-20 flex flex-col lg:flex-row items-center gap-10">
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="flex-1"
        >
          <img
            src="/img/building.jpg"
            alt="Gemstone Shaheen Tower"
            className="rounded-3xl shadow-xl hover:scale-[1.03] transition-transform duration-700 w-full object-cover"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="flex-1 space-y-6"
        >
          <h2 className="text-4xl font-bold text-gray-900">
            Gemstone Shaheen Tower
          </h2>
          <p className="text-gray-600 leading-relaxed text-justify">
            A landmark of modern living at Sher-e-Bangla Road, West Dhanmondi —
            designed by top structural engineers following BNBC standards.
            Experience superior architecture, natural light, and serene
            cross-ventilation for a healthy lifestyle.
          </p>

          <div className="bg-white border border-gray-100 rounded-3xl shadow-lg p-6">
            <ul className="space-y-2 text-gray-700 text-[15px]">
              <li>
                📍 <b>Location:</b> Sher-e-Bangla Road, Dhaka
              </li>
              <li>
                🏢 <b>Structure:</b> B+G+9 (10 Storied)
              </li>
              <li>
                🏠 <b>Flats:</b> 36 Units (4 per floor)
              </li>
              <li>
                📐 <b>Sizes:</b> 1650–1200 sqft
              </li>
              <li>
                🚗 <b>Parking:</b> Basement + Ground Floor
              </li>
              <li>
                🌿 <b>Roof Facilities:</b> Rooftop Garden, Lift Machine Room,
                Water Tank
              </li>
              <li>
                🏗️ <b>Developer:</b> Gemstone Real Estate Ltd.
              </li>
            </ul>
          </div>
        </motion.div>
      </div>

      {/* Divider */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent my-12"></div>

      {/* Project Section 2 */}
      <div className="max-w-7xl mx-auto px-6 py-20 flex flex-col-reverse lg:flex-row items-center gap-10">
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="flex-1 space-y-6"
        >
          <h2 className="text-4xl font-bold text-gray-900">Gemstone Primero</h2>
          <p className="text-gray-600 leading-relaxed text-justify">
            Nestled in the calm heart of Bashundhara R/A,{" "}
            <b>Gemstone Primero</b> redefines exclusivity with only seven
            luxurious residences — one per floor. Crafted for those who seek
            sophistication, privacy, and timeless comfort.
          </p>

          <div className="bg-white border border-gray-100 rounded-3xl shadow-lg p-6">
            <ul className="space-y-2 text-gray-700 text-[15px]">
              <li>
                📍 <b>Location:</b> Block F, Bashundhara, Dhaka
              </li>
              <li>
                🏢 <b>Building:</b> G+7 (8 Storied)
              </li>
              <li>
                🏠 <b>Flats:</b> 7 Units (1 per floor)
              </li>
              <li>
                📐 <b>Size:</b> 1950 sqft (Approx.)
              </li>
              <li>
                🚗 <b>Parking:</b> 7 Reserved Car Spaces
              </li>
              <li>
                🌿 <b>Roof Facilities:</b> Rooftop Community Space, Water Tank
              </li>
              <li>
                🏗️ <b>Developer:</b> Gemstone Real Estate Ltd.
              </li>
            </ul>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="flex-1"
        >
          <img
            src="/img/GemstoneCalalgoPrimero2.jpg"
            alt="Gemstone Primero"
            className="rounded-3xl shadow-xl hover:scale-[1.03] transition-transform duration-700 w-full object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default About;
